module.exports = __webpack_public_path__ + "img/day-night.12dddfc9.svg";